module.exports = {"post_code":"Street code","salutation":"Title","title":"Academic title"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locales/en-ZA.json
// module id = 2279
// module chunks = 260